import React from 'react'

export const UserPreferencesHeading:React.FC<{heading: string}> = ({heading}) => {
  return (
    <div className="text-center text-white font-semibold text-lg px-[35px] leading-[24px]">
      {heading}
    </div>
  )
}
